{
  "upload": {
    "heading": "Aggiungi le tue foto",
    "description": "A ogni foto corrisponderà un singolo prodotto",
    "choose": "Scegli foto",
    "photoSelected": "{ {count} } foto selezionata",
    "photoSelected_plural": "{ {count} } foto selezionate",
    "maxPhotos": "Puoi arrivare fino a { {count} } foto",
    "maxPhotos_plural": "Puoi arrivare fino a { {count} } foto",
    "continue": "Continua",
    "back": "Indietro",
    "loading-description": "Stiamo caricando le tue foto...",
    "more-purchase-less-price": "Più quadri ordini, meno spendi",
    "how-many-frames": "Quanti quadri vuoi aggiungere?",
    "description-mobile": "A ogni foto corrisponderà un singolo prodotto",
    "title": "Trascina e rilascia le tue foto qui",
    "subheading": "Puoi selezionare da 0 a 360 foto",
    "title-mobile": "Carica dalla galleria del tuo smartphone",
    "choose-or-take": "Scegli o scatta foto",
    "computer": "Computer",
    "google-photo": "Google Foto",
    "gallery": "Galleria",
    "my-photos": "Le tue foto",
    "upload-from": "Carica da",
    "upload-or-drag": "Carica le tue foto o trascinale in quest’area",
    "other-choises": "Oppure carica da",
    "long-press-zoom": "Premi a lungo sulle immagini per fare zoom",
    "subtitle-mobile": "Oppure carica da",
    "add": "Aggiungi foto",
    "smartphone": "Smartphone",
    "family-friends": "Famiglia e amici",
    "or-other-choises": "Oppure carica da",
    "upload-error-title": "Non è stato possibile caricare uno o più file",
    "upload-error-description": "Potrebbe essere corrotto o in un formato non supportato.  Ti preghiamo di verificare e riprovare.",
    "upload-error-description-list": "I seguenti file potrebbero essere corrotti o in un formato non supportato:",
    "show-error-list": "Mostra l’elenco completo",
    "upload-error-description-head": "I seguenti file: ",
    "upload-error-description-tail-counter": " ed altri {{counter_file}} potrebbero essere corrotti o in un formato non supportato.",
    "upload-error-description-tail": " potrebbero essere corrotti o in un formato non supportato.",
    "upload-computer-title": "Carica le tue foto",
    "upload-computer-description": "o trascinale in quest'area",
    "upload-from-other-source": "Oppure caricale da",
    "upload-from-computer": "Scegli foto",
    "upload-format": "Formati",
    "loading-wait": "Attendi qualche istante",
    "loading-login-google": "Stiamo collegando il tuo account Google",
    "qr-code": "Pronto a ricevere le foto",
    "upload-qr-title": "Prosegui sul tuo Smartphone",
    "upload-qr-description": "Inquadra questo codice con il tuo smartphone e segui le istruzioni",
    "upload-qr-loading-title": "Carica dal tuo Smartphone",
    "upload-qr-loading-description": "Attendi un istante, stiamo generando un QR code",
    "upload-family-title": "Famiglia e amici",
    "upload-family-description": "Copia questo link ed invialo ai tuoi famigliari ed amici",
    "upload-family-loading-description": "Attendi un istante, stiamo generando un collegamento",
    "retry": "Carica altre foto",
    "upload-gallery-title": "Carica dalla galleria del tuo smartphone",
    "upload-style": "Stile",
    "choose-with-minimum": "Scegli almeno {{photos}} foto",
    "upload-from-your-source": "Mentre attendi puoi caricare le tue foto da",
    "hide-error-list": "Chiudi elenco completo",
    "view-uploaded-photo": "Vedi foto caricate",
    "title-choose": "Scegli le foto",
    "choose-max": "Scegli {{photos}} foto",
    "error": {
      "corrupted-files": {
        "title": "Non è stato possibile caricare alcune foto",
        "description": "I seguenti file potrebbero essere corrotti o in un formato non supportato:",
        "cta": "Ok, grazie"
      },
      "low-memory": {
        "title": "La memoria del dispositivo è piena",
        "description": "Non riusciamo a caricare le foto che ti sono state inviate. Libera XX MB di spazio libero e prova a caricarle.",
        "cta": "Ok, grazie"
      },
      "network-unavailable": {
        "title": "Caricamento foto non riuscito",
        "description": "Controlla la connessione e riprova. Se il problema persiste, ricarica la pagina tra qualche minuto.",
        "cta": "Riprova"
      },
      "unknown": {
        "title": "Caricamento foto non riuscito",
        "description": "Qualcosa è andato storto e non è stato possibile caricare le foto che ti sono state inviate, prova a ricaricarle.",
        "cta": "Ok, grazie"
      }
    }
  },
  "customize": {
    "other_options": "Altre opzioni",
    "add-to-cart": "Aggiungi al carrello",
    "redo": "Ripeti",
    "undo": "Annulla",
    "add-project-title": "Aggiungi titolo al progetto",
    "add-frame": "Aggiungi",
    "delete-frame": "Elimina",
    "tutorial": "Tutorial",
    "save": "Salva",
    "no-frame": "Inizia a creare",
    "no-frame-description": "Carica le tue foto o trascinale in quest’area. A ogni foto corrisponderà un singolo prodotto.",
    "choose": "Aggiungi foto",
    "create-something-else": "Cerchi un'altra idea?",
    "create-new-project": "Crea un nuovo progetto",
    "you-want-delete-frame": "Vuoi eliminarlo?",
    "you-want-delete-frame-description": "Non sarà più possibile recuperare il progetto e dovrai rifarlo da capo",
    "delete": "Elimina",
    "abort": "Annulla",
    "other-options": "Altre opzioni",
    "default-project-title": "Il tuo prodotto",
    "go-to-site": "Torna al sito",
    "ignore": "Ignora",
    "suboptimal-quality": "La qualità della foto non è ottimale",
    "suboptimal-solution": "Puoi risolvere in diversi modi:",
    "change-photo": "Sostituisci con una foto di qualità superiore",
    "remove-zoom": "Rimuovi l'ingrandimento che hai applicato",
    "change-format": "Scegli un formato più piccolo",
    "keep-anyway": "Stampa comunque",
    "continue": "Continua",
    "no-frame-mobile": "Inizia a creare",
    "no-frame-description-mobile": "A ogni foto corrisponderà un singolo prodotto.",
    "see-other-products": "Vedi altri prodotti",
    "confirm": "Conferma",
    "applyAll": "Applica a tutti ({{price}}€)",
    "open_menu": "Apri menu",
    "color-correction": "Ideale per migliorare i colori delle tue foto, se non sono già state ritoccate.",
    "change": "Cambia",
    "add-another-frame": "Aggiungi un altro",
    "no-frame-description-new": "Carica le tue foto o trascinale in quest’area.",
    "empty-state-title": "Non vedi le tue foto?",
    "empty-state-description": "Riceverai una notifica appena le avremo caricate e le troverai nella sezione:",
    "empty-state-other-photos": "Oppure, carica altre foto",
    "empty-state-cta-second": "Carica foto",
    "empty-state-description-mobile": "Qui troverai le tue foto una volta caricate",
    "switch-to-set-3x": "Passa al set da 3 Quadretti",
    "switch-to-set-6x": "Passa al set da 6 Quadretti",
    "switch-to-set-9x": "Passa al set da 9 Quadretti"
  },
  "lookups": {
    "layout": "Layout",
    "glass": "Vetro acrilico",
    "format": "Formato",
    "frame-color": "Colore cornice",
    "passepartout-color": "Passe-partout",
    "passepartout-type": "Spazio foto",
    "correction": "Correzione colore",
    "front-surface": "Vetro acrilico",
    "passepartout": "Bordo",
    "front-surface-description": "Il vetro acrilico protegge e dona luminosità alla foto stampata su carta fotografica opaca.",
    "passepartout-description": "Puoi applicare un bordo bianco intorno alla foto per darle più risalto.",
    "correction-description": "Ideale per migliorare i colori delle tue foto, se non sono già state ritoccate.",
    "suboptimal": "Non ottimale",
    "side-color": "Colore bordo",
    "side-thickness": "Spessore",
    "border-type": "Bordo",
    "border-type-description": "Scegli l’effetto che preferisci per il bordo della tua tela e posiziona al centro i particolari importanti della foto.",
    "paper": "Finitura",
    "format-group-print_classic": "Classici",
    "format-group-print_classic-referencing-poster": "Poster e ingrandimenti",
    "format-group-poster": "Poster e ingrandimenti",
    "format-group-poster-referencing-print_classic": "Classiche",
    "format-defaultGroup": "",
    "format-referencingOtherGroup": "",
    "paper_color": "Colore",
    "text": "Testo",
    "format-group-print_pro": "Stampe Pro",
    "format-group-print_pro-referencing-poster_pro": "Poster e ingrandimenti Pro",
    "format-group-poster_pro": "Poster e ingrandimenti Pro",
    "format-group-poster_pro-referencing-print_pro": "Stampe Pro",
    "boxstyle": "Stile",
    "printtype": "Carta",
    "kit-type": "Quantità"
  },
  "filters": {
    "blackandwhite": "Black & White",
    "sepia": "Seppia",
    "crossprocess": "Cross Process",
    "route66": "Route 66",
    "vintage70": "Vintage",
    "softportrait": "Soft Portrait",
    "landscape": "Landscape",
    "drama": "Drama",
    "original": "Originale",
    "mix": "Mix"
  },
  "edit": {
    "frame": "Inquadra",
    "filters": "Filtri",
    "replace": "Sostituisci foto",
    "redo": "Ripeti",
    "undo": "Annulla",
    "back": "Salva e torna",
    "save": "Salva",
    "edit_photo": "Modifica foto",
    "edit-photo": "Modifica foto",
    "saving": "Salvataggio in corso",
    "saved": "Modifiche salvate",
    "saving_mobile": "Salvo...",
    "saving-mobile": "Salvo...",
    "add-photos": "Aggiungi foto",
    "restore": "Ripristina",
    "borders": "Bordi",
    "adjustments": "Regolazioni",
    "replace-mobile": "Sostituisci",
    "orientation": "Orientamento",
    "exit": "Chiudi modifiche",
    "save-modify": "Salva modifiche",
    "title": "Modifica",
    "flip-vertical": "Specchia verticale",
    "flip-horizontal": "Specchia orizzontale",
    "saved_mobile": "Salvato",
    "photo-next": "Foto successiva",
    "photo-prev": "Foto precedente",
    "photo-item": "Foto {{number}}"
  },
  "modal-exit-project": {
    "title": "Vuoi abbandonare il progetto?",
    "description": "Accedi o registrati per salvare il progetto, altrimenti andrà perso.",
    "cancel": "Esci dal progetto",
    "exit": "Accedi per salvare",
    "title-with-logged-user": "Vuoi uscire dal progetto?",
    "description-with-logged-user": "Grazie al salvataggio automatico, potrai recuperare il tuo lavoro dalla sezione I tuoi progetti.",
    "cancel-with-logged-user": "Annulla",
    "exit-with-logged-user": "Salva ed esci"
  },
  "modal-quality-alert": {
    "suboptimal-quality": "La qualità della foto \nnon è ottimale",
    "suboptimal-solution": "Puoi risolvere in diversi modi:",
    "change-photo": "Sostituisci foto",
    "remove-zoom": "Rimuovi l’ingrandimento che hai applicato alla foto",
    "change-format": "Scegli un altro formato",
    "close": "Stampa comunque",
    "change-format-or-photo": "Ti consigliamo di sostituirla con una foto di qualità superiore o di scegliere un formato più piccolo",
    "change-only-photo": "Ti consigliamo di sostituirla con una foto di qualità superiore",
    "suboptimal-quality-multiplr": "",
    "change-photo-clickable": "Sostituisci foto",
    "remove-zoom-clickable": "Rimuovi l'ingrandimento",
    "change-format-clickable": "Scegli un formato più piccolo",
    "sub-quality-multiple-description": "La foto potrebbe apparire sfocata, ma se per te è speciale, stampala comunque!",
    "continue": "Continua",
    "abort": "Annulla",
    "suboptimal-quality-multiple": "La qualità di alcune foto \nnon è ottimale",
    "fix": "Risolvi",
    "ignore": "Ignora",
    "quality-check": "Controlla qualità",
    "change-format-less-than": "Scegli un altro formato inferiore al {{format}} cm",
    "delete": "Elimina questo elemento",
    "sub-quality-multiple-subdescription": "Il ricordo è ciò che conta!",
    "print-anyway": "Stampa comunque"
  },
  "modal-empty-images": {
    "title": "Mancano delle foto\nnel tuo progetto",
    "description": "Verifica gli spazi rimasti vuoti\ne carica le tue foto per continuare",
    "check": "Verifica",
    "title-adhesive": "Ci sono dei quadri senza foto",
    "description-adhesive": "Aggiungi le foto mancanti per completare il set. Questo prodotto può essere acquistato solo in set da 3, 6 o 9 pezzi.",
    "check-adhesive": "Completa il set"
  },
  "modal-multiple-purchase": {
    "title": "Crea pareti bellissime!",
    "description": "Scegli le foto in base al numero di quadri che vuoi creare, più quadri ordini, meno spendi!",
    "option-3-5": "Aggiungi da 3 a 5 quadri",
    "option-6-8": "Aggiungi da 6 a 8 quadri",
    "option-9-more": "Aggiungi da 9 quadri in su",
    "option-1-2": "Aggiungi da 1 a 2 quadri"
  },
  "general": {
    "frame": "quadro",
    "frames": "quadri",
    "save": "Salva",
    "chat": "Chat",
    "product": "prodotto",
    "products": "prodotti",
    "modal": "modale",
    "editor": "Editor PhotoSì",
    "set-of-frames": "Set da {{count}} Quadretto",
    "set-of-frames_plural": "Set da {{count}} Quadretti",
    "frame-counter": "Quadro",
    "frame-counter_plural": "Quadri",
    "set-of-frames-counter": "Quadretto",
    "set-of-frames-counter_plural": "Quadretti",
    "photo": "foto",
    "products-counter": "{{count}} prodotto",
    "products-counter_plural": "{{count}} prodotti",
    "drag": "Rilascia qui le tue foto per aggiungerle al progetto"
  },
  "modal-upload-to-cart": {
    "title": "Stiamo caricando le tue foto",
    "description": "Non chiudere la pagina, ci vorrà solo qualche istante",
    "abort": "Annulla",
    "title-complete": "Caricamento completato!",
    "description-complete": "I tuoi prodotti sono nel carrello",
    "eta-minutes-seconds": "Mancano solo {{minutes}} e {{seconds}}",
    "eta-minutes": "Manca solo {{minutes}}",
    "eta-minutes_plural": "Mancano solo {{minutes}}",
    "eta-seconds": "Quasi fatto, mancano solo {{seconds}}",
    "minutes": "{{count}} minuto",
    "minutes_plural": "{{count}} minuti",
    "seconds": "{{count}} secondi",
    "title-mobile": "",
    "description-mobile": "",
    "description-bad-network": "La connessione è un po' lenta e ci vorrà più del previsto, rimani su questa pagina per non interrompere",
    "description-slow-network": "Ci vorrà più del previsto, ma siamo a buon punto, rimani su questa pagina per non interrompere"
  },
  "modal-error-cart": {
    "title": "Il caricamento delle foto non è riuscito",
    "description": "Ci potrebbero essere problemi di connessione, controlla il collegamento alla rete e riprova.",
    "retry": "Riprova",
    "title-mobile": "Il caricamento delle foto non è riuscito",
    "description-mobile": "Ci potrebbero essere problemi di connessione, controlla il collegamento alla rete e riprova."
  },
  "rotate_to_portrait": {
    "message": "Ruota il dispositivo in verticale per continuare"
  },
  "modal-save-changes": {
    "title": "Vuoi salvare le modifiche?",
    "description": "Hai delle modifiche non salvate, tornando indietro le perderai.",
    "save": "Salva",
    "saving": "Sto salvando...",
    "discard": "Ignora"
  },
  "modal-apply-all": {
    "title": "Confermi di voler estende la modifica a tutti gli elementi?",
    "abort": "Annulla",
    "confirm": "Conferma"
  },
  "loading": {
    "0": "",
    "1": "Attendi ancora qualche istante...",
    "2": "Il caricamento sta richiedendo più tempo del solito, ci scusiamo per l'attesa..."
  },
  "toast": {
    "fix": "Risolvi",
    "suboptimal-quality": "Qualità della foto non ottimale",
    "uploading-photo-error": "Errore nel caricamento della foto",
    "uploading-photos-error": "Errore nel caricamento delle foto",
    "frame-deleted-successfully": "Il tuo quadro è stato eliminato con successo",
    "invalid-photo-format": "Il formato scelto non è supportato",
    "invalid-of-some-photos-format": "Il formato scelto per alcune foto non è supportato",
    "valid-photo-format-reminder": "Ricorda di selezionare solo file con i formati PNG, JPG, JPEG e HEIC",
    "incognito-hint": "Nella modalità in incognito alcune funzioni dell'editor potrebbero non essere disponibili",
    "accept-and-close": "Ok, chiudi",
    "product-deleted-successfully": "Prodotto eliminato con successo",
    "check": "Controlla",
    "cuts-check-hint": "Alcune immagini sono state tagliate, controlla l’inquadratura",
    "product-option-applied-successfully": "L’opzione {{option}} è stata applicata correttamente",
    "products-deleted-successfully": "Prodotti eliminati con successo",
    "loading": "",
    "min-product-missing": "Questo prodotto prevede almeno {{min_value}} foto.",
    "add-missing": "Aggiungi",
    "accept": "Ho capito",
    "project-not-uploaded": "Alcune immagini non sono state caricate e le abbiamo rimosse. Puoi riprovare.",
    "min-product-missing_happy_case_classic": "Questa box prevede almeno {{min_value}} foto.",
    "min-product-missing_happy_case_vintage": "Questa box prevede almeno {{min_value}} foto.",
    "min-product-missing_fotokit_homedecor": "Questo FotoKit prevede almeno {{min_value}} foto.",
    "min-product-missing_fotokit_miniscrap": "Questo FotoKit prevede almeno {{min_value}} foto.",
    "complete-missing_happy_case_classic": "Questa box è completa! Puoi aggiungerla al carrello quando desideri.",
    "complete-missing_happy_case_vintage": "Questa box è completa! Puoi aggiungerla al carrello quando desideri.",
    "complete-missing_fotokit_homedecor": "Questo FotoKit è completo! Puoi aggiungerlo al carrello quando desideri.",
    "complete-missing_fotokit_miniscrap": "Questo FotoKit è completo! Puoi aggiungerlo al carrello quando desideri.",
    "created_newbox_happy_case_classic": "Questa box è completa! Abbiamo aggiunto le restanti foto in una nuova box.",
    "created_newbox_happy_case_vintage": "Questa box è completa! Abbiamo aggiunto le restanti foto in una nuova box.",
    "created_newbox_fotokit_homedecor": "Questo FotoKit è completo! Abbiamo aggiunto le restanti foto in un nuovo FotoKit.",
    "created_newbox_fotokit_miniscrap": "Questo FotoKit è completo! Abbiamo aggiunto le restanti foto in un nuovo FotoKit.",
    "show": "Vedi",
    "photos-added": "Foto aggiunte nella sezione \"Le tue foto\"",
    "products-added": "{{count}} foto aggiunta con successo",
    "products-added_plural": "{{count}} foto aggiunte con successo",
    "duplicate": "Prodotto duplicato con successo",
    "duplicate_plural": "Prodotti duplicati con successo",
    "products-removed": "Foto eliminata con successo",
    "products-removed_plural": "{{count}} foto eliminate con successo",
    "products-restored": "Foto ripristinata con successo",
    "products-restored_plural": "{{count}} foto ripristinate con successo",
    "product-option-updated": "Opzione {{option}} aggiornata",
    "product-replaced": "Foto sostituita con successo"
  },
  "modal-picker-google-photo": {
    "title-upload": "Carica da Google Foto",
    "description-upload": "Collegati e scegli le tue foto preferite",
    "title-logged": "Il tuo account è collegato a Google Foto!",
    "description-logged": "Per proteggere la tua privacy, Google permette a PhotoSì di accedere solo alle foto che scegli tu.",
    "choose-photo": "Scegli foto",
    "login": "Collegati a Google Foto",
    "logged-with": "Connesso con",
    "logout": "Disconnetti",
    "errors": {
      "no-access": "Non possiamo accedere alle tue foto.\nPer darci il consenso devi disconnetterti e accedere di nuovo a Google Foto."
    }
  },
  "chat": {
    "initialMessage": "Ciao! Sono Sara, l'assistente virtuale di PhotoSì. Se cerchi un regalo, un prodotto o hai bisogno di una mano, sono qui per te.",
    "title": "PhotoSì",
    "subtitle": "",
    "footer": "",
    "inputPlaceholder": "Scrivi qui la tua domanda..."
  },
  "borders": {
    "mirrored": "Specchiato",
    "extended": "Allungato",
    "folded": "Ripiegato"
  },
  "canvas": {
    "border-text-top": "Bordo superiore",
    "border-text-right": "Bordo laterale",
    "border-text-bottom": "Bordo inferiore",
    "border-text-left": "Bordo laterale"
  },
  "adjustments": {
    "brightness": "Luminosità",
    "contrast": "Contrasto",
    "saturation": "Saturazione",
    "restore": "Ripristina",
    "close": "Fine"
  },
  "lookups-options": {
    "Folded": "Ripiegato",
    "Mirrored": "Specchiato",
    "Extended": "Allungato",
    "homedecor": {
      "format-24x32": "24x32 cm",
      "format-32x24": "32x24 cm",
      "format-30x40": "30x40 cm",
      "format-40x30": "40x30 cm",
      "format-40x60": "40x60 cm",
      "format-60x40": "60x40 cm",
      "format-50x70": "50x70 cm",
      "format-70x50": "70x50 cm",
      "format-16x16": "16x16 cm",
      "format-18x24": "18x24 cm",
      "format-24x18": "24x18 cm",
      "format-24x24": "24x24 cm",
      "format-30x30": "30x30 cm",
      "format-40x40": "40x40 cm",
      "format-50x50": "50x50 cm",
      "format-70x70": "70x70 cm",
      "format-70x100": "70x100 cm",
      "format-100x70": "100x70 cm",
      "format-20x20": "20x20 cm",
      "format-20x30": "20x30 cm",
      "format-30x20": "30x20 cm",
      "format-12x12": "12x12 cm",
      "format-12x18": "12x18 cm",
      "format-18x12": "18x12 cm",
      "format-15x15": "15x15 cm",
      "format-15x20": "15x20 cm",
      "format-20x15": "20x15 cm",
      "format-17x17": "17x17 cm",
      "format-50x100": "50x100 cm",
      "format-100x50": "100x50 cm",
      "format-60x90": "60x90 cm",
      "format-90x60": "90x60 cm",
      "format-90x90": "90x90 cm",
      "format-90x120": "90x120 cm",
      "format-120x90": "120x90 cm",
      "format-120x120": "120x120 cm",
      "format-13x18": "13x18 cm",
      "format-18x13": "18x13 cm",
      "format-60x60": "60x60 cm",
      "format-100x100": "100x100 cm",
      "frame-color-BLACK": "Nero",
      "frame-color-WHITE": "Bianco",
      "frame-color-WOOD": "Legno",
      "frame-color-SILVER": "Argento",
      "frame-color-GOLD": "Oro",
      "frame-color-BRONZE": "Bronzo",
      "passepartout-color-WHITE": "Bianco",
      "passepartout-color-BLACK": "Nero",
      "passepartout-type-PHYSICAL_STANDARD": "Classico",
      "passepartout-type-PHYSICAL_DECENTERED": "Decentrato",
      "correction-YES": "Sì",
      "correction-NO": "No",
      "passepartout-NO": "senza bordo",
      "passepartout-YES": "con bordo",
      "layout-1x": "1x",
      "layout-4x": "4x",
      "layout-6x": "6x",
      "layout-9x": "9x",
      "layout-1x_FULL_PHOTO": "full foto",
      "front-surface-NO": "No",
      "front-surface-YES": "Sì",
      "side-color-WHITE": "Bianco",
      "side-color-BLACK": "Nero",
      "side-thickness-2_CM": "2 cm",
      "side-thickness-4_CM": "3,5 cm",
      "border-type-Folded": "Ripiegato",
      "border-type-Mirrored": "Specchiato",
      "border-type-Extended": "Allungato",
      "kit-type-3x": "Set 3 pezzi",
      "kit-type-6x": "Set 6 pezzi",
      "kit-type-9x": "Set 9 pezzi",
      "kit-type-3x_selected-lookup": "Set 3 pz",
      "kit-type-6x_selected-lookup": "Set 6 pz",
      "kit-type-9x_selected-lookup": "Set 9 pz"
    },
    "print": {
      "format-7x10": "7x10 cm",
      "format-10x10": "10x10 cm",
      "format-10x13": "10x13 cm",
      "format-10x15": "10x15 cm",
      "format-10x_PANORAMIC": "10 cm variabile",
      "format-12x16": "12x16 cm",
      "format-12x_PANORAMIC": "12 cm variabile",
      "format-13x13": "13x13 cm",
      "format-13x17.33": "13x17 cm",
      "format-13x19.5": "13x19 cm",
      "format-13x_PANORAMIC": "13 cm variabile",
      "format-15x22": "15x22 cm",
      "format-20x27": "20x27 cm",
      "format-30x45": "30x45 cm",
      "format-40x50": "40x50 cm",
      "format-50x75": "50x75 cm",
      "format-24x32": "24x32 cm",
      "format-32x24": "32x24 cm",
      "format-30x40": "30x40 cm",
      "format-40x30": "40x30 cm",
      "format-40x60": "40x60 cm",
      "format-60x40": "60x40 cm",
      "format-50x70": "50x70 cm",
      "format-70x50": "70x50 cm",
      "format-16x16": "16x16 cm",
      "format-18x24": "18x24 cm",
      "format-24x18": "24x18 cm",
      "format-24x24": "24x24 cm",
      "format-30x30": "30x30 cm",
      "format-40x40": "40x40 cm",
      "format-50x50": "50x50 cm",
      "format-50x60": "50x60 cm",
      "format-70x70": "70x70 cm",
      "format-70x100": "70x100 cm",
      "format-100x70": "100x70 cm",
      "format-20x20": "20x20 cm",
      "format-20x30": "20x30 cm",
      "format-30x20": "30x20 cm",
      "format-12x12": "12x12 cm",
      "format-12x18": "12x18 cm",
      "format-18x12": "18x12 cm",
      "format-15x15": "15x15 cm",
      "format-15x20": "15x20 cm",
      "format-20x15": "20x15 cm",
      "format-17x17": "17x17 cm",
      "format-50x100": "50x100 cm",
      "format-100x50": "100x50 cm",
      "format-60x90": "60x90 cm",
      "format-90x60": "90x60 cm",
      "format-90x90": "90x90 cm",
      "format-90x120": "90x120 cm",
      "format-120x90": "120x90 cm",
      "format-120x120": "120x120 cm",
      "format-13x18": "13x18 cm",
      "format-18x13": "18x13 cm",
      "format-60x60": "60x60 cm",
      "format-100x100": "100x100 cm",
      "frame-color-BLACK": "Nero",
      "frame-color-WHITE": "Bianco",
      "frame-color-WOOD": "Legno",
      "frame-color-SILVER": "Argento",
      "frame-color-GOLD": "Oro",
      "frame-color-BRONZE": "Bronzo",
      "passepartout-color-WHITE": "Bianco",
      "passepartout-color-BLACK": "Nero",
      "passepartout-type-PHYSICAL_STANDARD": "Classico",
      "passepartout-type-PHYSICAL_DECENTERED": "Decentrato",
      "correction-YES": "Sì",
      "correction-YES-description": "Ideale per migliorare i colori delle tue foto, se non sono già state ritoccate.",
      "correction-NO": "No",
      "correction-NO-description": "",
      "passepartout-NO": "No",
      "passepartout-YES": "Sì",
      "layout-1x": "1x",
      "layout-4x": "4x",
      "layout-6x": "6x",
      "layout-9x": "9x",
      "layout-1x_FULL_PHOTO": "full foto",
      "front-surface-NO": "No",
      "front-surface-YES": "Sì",
      "side-color-WHITE": "Bianco",
      "side-color-BLACK": "Nero",
      "side-thickness-2_CM": "2 cm",
      "side-thickness-4_CM": "3,5 cm",
      "border-type-Folded": "Ripiegato",
      "border-type-Mirrored": "Specchiato",
      "border-type-Extended": "Allungato",
      "paper-GLOSSY": "Lucida",
      "paper-GLOSSY-description": "Un’esplosione di luce per i tuoi scatti più vivaci",
      "paper-MATTE": "Opaca",
      "paper-MATTE-description": "Finitura vellutata ed elegante, senza riflessi",
      "format-15x22.5": "15x22 cm",
      "format-variable": " cm",
      "format-8x10": "8x10 cm",
      "format-12x15": "12x15 cm",
      "format-20x25": "20x25 cm",
      "format-10x00": "10 cm variabile",
      "format-12x00": "12 cm variabile",
      "format-13x00": "13 cm variabile",
      "format-13x19": "13x19 cm",
      "format-24x30": "24x30 cm",
      "format-24x36": "24x36 cm",
      "format-30x60": "30x60 cm",
      "format-35x35": "35x35 cm",
      "format-35x50": "35x50 cm",
      "format-60x80": "60x80 cm",
      "boxstyle-JUNGLE": "Jungle",
      "boxstyle-LOVE_IS": "Love is",
      "boxstyle-BLOOM": "Bloom",
      "boxstyle-OCEAN": "Ocean",
      "boxstyle-MOON": "Moon",
      "boxstyle-SUNSHINE": "Sunshine",
      "boxstyle-LIFE": "Life",
      "boxstyle-JUNGLE-description": "",
      "boxstyle-LOVE_IS-description": "",
      "boxstyle-BLOOM-description": "",
      "boxstyle-OCEAN-description": "",
      "boxstyle-MOON-description": "",
      "boxstyle-SUNSHINE-description": "",
      "boxstyle-LIFE-description": "",
      "boxstyle-CHRISTMAS": "Magic Christmas",
      "boxstyle-FLOWER": "Flower",
      "boxstyle-GAME": "Game",
      "boxstyle-GREEN": "Green",
      "boxstyle-WONDER": "Wonder",
      "boxstyle-CHRISTMAS-description": "",
      "boxstyle-FLOWER-description": "",
      "boxstyle-GAME-description": "",
      "boxstyle-GREEN-description": "",
      "boxstyle-WONDER-description": "",
      "format-10x13.33": "10x13 cm",
      "printtype-PHOTOGRAPHIC": "Carta fotografica Fujifilm",
      "printtype-PHOTOGRAPHIC-active-label": "Fujifilm",
      "printtype-PHOTOGRAPHIC-description": "• Per chi ama la carta tradizionale\n• Ideale per scatti professionali",
      "printtype-INKJET": "Carta fotografica PhotoSì",
      "printtype-INKJET-active-label": "PhotoSì",
      "printtype-INKJET-description": "• Resa cromatica eccellente\n• Scelta ecosostenibile",
      "boxstyle-LOVE_IS_SPECIAL": "Love you",
      "boxstyle-LOVE_IS_SPECIAL-description": ""
    },
    "kit-type": {
      "3x": "set da 3 pezzi",
      "6x": "set da 6 pezzi",
      "9x": "set da 9 pezzi"
    }
  },
  "modal-privacy-policy": {
    "privacy-policy-info": "Informativa sulla Privacy",
    "editor-privacy-policy-info": "Informativa sull’uso dell’editor",
    "main-content": "Durante l’uso del nostro editor fotografico, utilizziamo una tecnologia del tuo browser chiamata OPFS – Origin Private File System. Questo sistema ci permette di gestire in modo più veloce e sicuro i file che stai modificando, direttamente sul tuo dispositivo.",
    "paragraph-1-title": "Cosa significa per te?",
    "paragraph-1-content-1": "Tutto il lavoro che fai rimane privato e sicuro, dentro al tuo browser.",
    "paragraph-1-content-2": "I tuoi file NON vengono inviati ai nostri server in fase di elaborazione del progetto.",
    "paragraph-2-title": "Come proteggiamo la tua privacy?",
    "paragraph-2-content-1": "Nessun dato viene condiviso o tracciato attraverso OPFS.",
    "paragraph-2-content-2": "Non abbiamo accesso ai tuoi file salvati localmente.",
    "paragraph-2-content-3": "I dati restano accessibili solo a te e solo tramite lo stesso browser e dispositivo.",
    "know-more-1": "Vuoi saperne di più? Consulta la nostra",
    "privacy-policy": "Privacy Policy",
    "know-more-2": "completa per tutti i dettagli su come trattiamo i tuoi dati e i tuoi diritti.",
    "thanks": "Grazie per la fiducia e buon lavoro creativo con il nostro editor!"
  },
  "header": {
    "photo": "Le tue foto",
    "save": "Salva",
    "saved": "Salvato!",
    "total": "Totale",
    "products": "prodotti",
    "go-to-cart": "Aggiungi al carrello",
    "confirm": "Conferma",
    "product": "prodotto",
    "product_plural": "prodotti",
    "articles": "articoli:",
    "add-project-title": "Aggiungi titolo al progetto",
    "save-project-title": "Salva titolo del progetto",
    "edit-project-title": "Modifica titolo del progetto",
    "save-project": "Salva il progetto",
    "saving-project": "Salvataggio in corso",
    "project-saved": "Progetto salvato",
    "uploading": "Caricamento foto in corso",
    "photo-notification": "Le tue foto — nuove immagini disponibili"
  },
  "discounts-tooltip": {
    "prints-classic": "Stampe Classiche",
    "prints-vintage": "Stampe Vintage",
    "prints-pro": "Stampe Classiche Pro",
    "n-units-size": "{{quantity}} unità ({{format}})",
    "print_classic": "Stampe Classiche",
    "poster": "Poster e Ingrandimenti",
    "print_vintage": "Stampe Vintage",
    "happy_case_classic": "Happy Case Classic",
    "happy_case_vintage": "Happy Case Vintage",
    "fotokit_homedecor": "FotoKit Home Decor",
    "fotokit_miniscrap": "FotoKit Mini Scrap",
    "print_classic_with_border": "Stampe con bordo"
  },
  "discounts-table": {
    "prints-title": "Più stampi, meno spendi!",
    "prints-description": "Hai raggiunto il -{{discount}}% di sconto!",
    "prints-from-to": "da {{from}} a {{to}} foto",
    "prints-from-more": "da {{from}} in su",
    "price-discount": "da {{price}}€",
    "unit-discount": "cad.",
    "prints-to-reach": "Aggiungi altre {{photos}} foto per il -{{discount}}% di sconto",
    "greetings": "Congratulazioni!",
    "photo": "{{photos}} foto",
    "prints-subtitle": "Ecco come ottenere gli sconti quantità sulle stampe",
    "discover-discount": "Scopri",
    "prints-to-reach-head": "Aggiungi ",
    "prints-to-reach-middle": "{{count}} foto",
    "prints-to-reach-middle_plural": "{{count}} foto",
    "prints-to-reach-tail": " per il {{discount}} di sconto",
    "prints-description-mobile": "Sconti per il formato scelto: {{format}}"
  },
  "modal-suggested-format": {
    "title": "Formato suggerito",
    "option-1": "10x10 cm",
    "description-1": "Quadrato",
    "option-2": "10x13 cm",
    "description-2": "Ideale per evitare tagli alle tue foto",
    "option-3": "10x15 cm",
    "description-3": "Standard per Album con bustine",
    "option-4": "10 cm variabile",
    "description-4": "Mantiene le proporzioni originali. Ogni foto può avere dimensioni diverse.",
    "continue": "Continua",
    "suggested": "Consigliato"
  },
  "actions": {
    "add_x": "Aggiungi {{x}}",
    "remove_x": "Rimuovi {{x}}",
    "edit_x": "Modifica {{x}}",
    "close_x": "Chiudi {{x}}",
    "open_x": "Apri {{x}}",
    "rotate_left": "Ruota a sinistra",
    "rotate_right": "Ruota a destra",
    "increase_zoom": "Zoom +",
    "reduce_zoom": "Zoom -",
    "drag_or_edit": "Trascina o Modifica",
    "slide_right": "Trascina a destra",
    "slide_left": "Trascina a sinistra",
    "select_x": "Seleziona {{x}}",
    "edit": "Modifica",
    "duplicate": "Duplica",
    "save_and_return": "Salva e torna",
    "action-list": "Azioni",
    "delete": "Elimina",
    "replica": "Copie",
    "add_border": "Aggiungi un bordo",
    "zoom": "Anteprima",
    "options": "Opzioni",
    "select": "Seleziona",
    "quality": "Qualità scarsa",
    "increase": "Aggiungi",
    "decrease": "Diminuisci",
    "format": "Formato",
    "finishing": "Finitura",
    "quantity": "Quantità",
    "save": "Salva modifiche",
    "quit_without_save": "Esci senza salvare",
    "resolve-quality": "Risolvi qualità",
    "sub-quality": "Qualità non ottimale",
    "paper": "Finitura carta",
    "change-format": "Cambia formato",
    "print-options": "Visualizza opzioni di stampa",
    "choose-format": "Scegli formato",
    "save_and_close": "Salva e chiudi",
    "close": "Chiudi",
    "select_photo": "Seleziona foto numero {{number}}, {{count}} copia",
    "select_photo_plural": "Seleziona foto numero {{number}}, {{count}} copie",
    "deselect_photo": "Deseleziona foto numero {{number}}, {{count}} copia",
    "deselect_photo_plural": "Deseleziona foto numero {{number}}, {{count}} copie"
  },
  "photo-drawer": {
    "my-photos": "Le tue foto",
    "your-photos": "Le tue foto",
    "order-by": "Ordina per",
    "upload": "Carica foto",
    "upload-more": "Carica altre foto",
    "upload-from-gallery": "Carica dalla galleria",
    "add-n-photos": "Aggiungi {{number}} foto al progetto",
    "select-to-add": "Seleziona le foto per aggiungerle",
    "shot-date": "Data di scatto",
    "upload-date": "Data di caricamento",
    "adding": "Aggiungo...",
    "photos-added-to-project": "Foto aggiunte al progetto!",
    "select-photo": "Seleziona foto",
    "name": "Nome del file",
    "shot-date-most-recent": "Data di scatto: dal più recente",
    "shot-date-less-recent": "Data di scatto: dal meno recente",
    "upload-date-most-recent": "Data di caricamento: dal più recente",
    "upload-date-less-recent": "Data di caricamento: dal meno recente",
    "name-alphabetic": "Nome del file: A-Z",
    "name-alphabetic-reverse": "Nome del file: Z-A",
    "upload-from": "Carica da",
    "waiting-upload": "Attendi il caricamento delle foto...",
    "empty-text": "Qui troverai le tue foto una \nvolta caricate",
    "add-photos": "Aggiungi foto al progetto"
  },
  "modal-picker-my-photos": {
    "title": "Le tue foto",
    "deselect-all": "Deseleziona tutto",
    "confirm": "Conferma",
    "more-print-less-price": "Più stampi, meno spendi!",
    "add-n-photos-to-x-discount": "Con {{n}} stampe raggiungi il {{x}}% di sconto",
    "select-all": "Seleziona tutto",
    "progress": "Stiamo caricando le foto...",
    "completed": "Completato",
    "delete-selected": "Elimina",
    "loading": "Caricamento in corso...",
    "waiting": "Attendi qualche istante...",
    "continue": "Continua",
    "black": "Cornice nera",
    "white": "Cornice bianca",
    "3x": "Set 3 Quadretti",
    "6x": "Set 6 Quadretti",
    "9x": "Set 9 Quadretti",
    "3x_mobile": "3 Quadretti",
    "6x_mobile": "6 Quadretti",
    "9x_mobile": "9 Quadretti",
    "options-title": "Scegli il set",
    "options-title-mobile": "Colore e quantità",
    "options-header-title-mobile": "Set Quadretti"
  },
  "add-other-products": {
    "add-other-products": "Vuoi aggiungere altro?",
    "prints-classic": "Stampe Classiche",
    "prints-vintage": "Stampe Vintage",
    "prints-pro": "Stampe classiche Pro",
    "frame": "Quadri con cornice",
    "frame-pro": "Quadri con cornice Pro",
    "add": "Aggiungi",
    "from-x": "a partire da {{price}}"
  },
  "tooltip-save-project": {
    "title": "Titolo",
    "auto-saved": "Progetto salvato in automatico!",
    "last-save_date_hour": "Ultimo salvataggio: {{date}} alle {{hour}}",
    "saving": "Stiamo salvando...",
    "placeholder": "Progetto 1",
    "edit-auto-saved": "Salvato! Ogni modifica viene salvata automaticamente"
  },
  "authentication": {
    "landing-title": "Accedi o registrati",
    "landing-subtitle": "Per salvare un progetto devi accedere con il tuo account o registrarti.",
    "login-title": "Che bello rivederti!",
    "login-subtitle": "",
    "check-email-title": "Inserisci l'e-mail",
    "check-email-subtitle": "",
    "forgot-password-title": "C'è posta per te!",
    "forgot-password-subtitle": "Ti abbiamo inviato un'e-mail per creare una nuova password. Se non la trovi ti suggeriamo di dare un'occhiata anche alla posta indesiderata.",
    "signup-title": "Crea il tuo account",
    "signup-subtitle": "",
    "signup-completed-title": "Il tuo account è stato creato con successo!",
    "signup-completed-subtitle": "",
    "signup-completed-cta-label": "Chiudi",
    "manage-consents-title": "Gestisci i tuoi consensi",
    "manage-consents-subtitle": "",
    "vat-user-signup-completed-title": "Il tuo account è stato creato con successo!",
    "vat-user-signup-completed-subtitle": "Puoi inserire i tuoi dati di partita Iva in un secondo momento nella sezione profilo e ottenere lo sconto del 40%",
    "vat-user-signup-completed-cta-label": "Compila più tardi",
    "login-page-landing-title": "Accedi o registrati",
    "login-page-landing-subtitle": "Per continuare a lavorare al tuo progetto, accedi con il tuo account o registrati."
  },
  "action-bar": {
    "all": "Tutto",
    "cut": "Con taglio"
  },
  "colors": {
    "black": "Nero",
    "white": "Bianco",
    "grey": "Grigio",
    "greige": "Tortora",
    "hazelnut": "Nocciola",
    "beige": "Beige",
    "yellow": "Giallo",
    "cream": "Crema",
    "vanilla": "Vaniglia",
    "peach": "Pesca",
    "ivory": "Cipria",
    "pink": "Rosa",
    "candy": "Confetto",
    "peony": "Peonia",
    "fuchsia": "Fucsia",
    "red": "Rosso",
    "lavender": "Lavanda",
    "lilac": "Lilla",
    "ice": "Azzurro",
    "sky": "Cielo",
    "indigo": "Indaco",
    "blue": "Blu",
    "lake": "Acqua",
    "mint": "Menta",
    "green": "Verde"
  },
  "modal-configuration-steps": {
    "band-title": "Scegli la misura",
    "format-title": "Scegli il formato",
    "avoid-cuts": "Come evitare tagli alle foto",
    "continue": "Continua",
    "formats-content": {
      "10x13": "Formato predefinito degli smartphone",
      "13x19.5": "Standard per cornici e album portafoto",
      "8x10": "Piccolo formato, grandi emozioni da custodire.",
      "15x22.5": "Standard per cornici e album portafoto",
      "20x27": "",
      "13x13": "Quadrato",
      "20x30": "",
      "40x50": "",
      "50x50": "",
      "12x15": "La misura giusta per rivivere ogni istante con calore.",
      "15x15": "Quadrato",
      "20x25": "Un ricordo che prende spazio e illumina la stanza.",
      "13x17.33": "Formato predefinito degli smartphone",
      "12x18": "Standard per cornici e album portafoto",
      "40x40": "",
      "40x60": "",
      "15x20": "Formato predefinito degli smartphone",
      "50x70": "",
      "50x60": "",
      "12x12": "Quadrato",
      "50x75": "",
      "10x10": "Quadrato",
      "7x10": "Standard per cornici e album portafoto",
      "30x45": "",
      "10x15": "Standard per cornici e album portafoto",
      "12x16": "Formato predefinito degli smartphone",
      "30x40": "",
      "20x20": "",
      "8x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "12x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "30x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "20x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "13x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "7x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "10x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "40x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "15x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "50x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "suggested": "Ideale per evitare tagli alle tue foto",
      "13x19": "Standard per cornici e album portafoto",
      "15x22": "Standard per cornici e album portafoto",
      "13x17": "Formato predefinito degli smartphone",
      "10x00": "Mantiene le proporzioni originali dello scatto",
      "8x00": "Mantiene le proporzioni originali dello scatto",
      "12x00": "Mantiene le proporzioni originali dello scatto",
      "30x00": "Mantiene le proporzioni originali dello scatto",
      "20x00": "Mantiene le proporzioni originali dello scatto",
      "13x00": "Mantiene le proporzioni originali dello scatto",
      "7x00": "Mantiene le proporzioni originali dello scatto",
      "40x00": "Mantiene le proporzioni originali dello scatto",
      "15x00": "Mantiene le proporzioni originali dello scatto",
      "50x00": "Mantiene le proporzioni originali dello scatto",
      "18x24": "",
      "24x24": "",
      "24x30": "",
      "24x36": "",
      "30x30": "",
      "35x35": "",
      "35x50": "",
      "30x60": "",
      "60x80": "",
      "70x100": "",
      "print_classic": {
        "7x00": "Mantiene le proporzioni originali dello scatto",
        "7x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
        "10x10": "Formato quadrato",
        "10x13": "Formato predefinito degli smartphone",
        "10x15": "Standard per cornici e album portafoto",
        "10x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
        "10x00": "Mantiene le proporzioni originali dello scatto",
        "12x12": "Formato quadrato",
        "12x16": "Formato predefinito degli smartphone",
        "12x18": "Standard per cornici e album portafoto",
        "12x00": "Mantiene le proporzioni originali dello scatto",
        "12x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
        "13x13": "Formato quadrato",
        "13x17": "Formato predefinito degli smartphone",
        "13x17.33": "Formato predefinito degli smartphone",
        "13x19": "Standard per cornici e album portafoto",
        "13x19.5": "Standard per cornici e album portafoto",
        "13x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
        "13x00": "Mantiene le proporzioni originali dello scatto",
        "15x15": "Formato quadrato",
        "15x20": " ",
        "15x22.5": " ",
        "15x22": " ",
        "15x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
        "15x00": "Mantiene le proporzioni originali dello scatto",
        "7x10": "Formato mini, ideale per i biglietti d'auguri"
      },
      "poster": {
        "20x20": "",
        "20x27": "",
        "20x30": "",
        "30x40": "",
        "30x45": "",
        "40x40": "",
        "40x50": "",
        "40x60": "",
        "50x50": "",
        "50x70": "",
        "50x75": "",
        "50x60": ""
      },
      "print_vintage": {
        "8x10": "Piccolo formato, grandi emozioni da custodire.",
        "12x15": "La misura giusta per rivivere ogni istante con calore.",
        "20x25": "Un ricordo che prende spazio e illumina la stanza."
      },
      "print_pro": {
        "10x13": "Formato predefinito degli smartphone",
        "10x15": "Standard per cornici e album portafoto",
        "12x16": "Formato predefinito degli smartphone",
        "12x18": "Standard per cornici e album portafoto",
        "13x17.33": "Formato predefinito degli smartphone",
        "13x17": "Formato predefinito degli smartphone",
        "13x19": "Standard per cornici e album portafoto",
        "13x19.5": "Standard per cornici e album portafoto",
        "15x20": " ",
        "15x22.5": " ",
        "15x22": " ",
        "7x10": "Formato mini, ideale per i biglietti d'auguri"
      },
      "poster_pro": {
        "20x20": "",
        "18x24": "",
        "20x25": "",
        "24x24": "",
        "20x30": "",
        "24x30": "",
        "24x36": "",
        "30x30": "",
        "30x45": "",
        "30x40": "",
        "35x35": "",
        "40x40": "",
        "35x50": "",
        "30x60": "",
        "40x50": "",
        "50x50": "",
        "40x60": "",
        "50x70": "",
        "50x60": "",
        "50x75": "",
        "60x80": "",
        "70x100": ""
      },
      "happy_case_classic": {
        "one": "",
        "other": ""
      },
      "happy_case_vintage": {
        "one": "",
        "other": ""
      },
      "fotokit_homedecor": {
        "one": "",
        "other": ""
      },
      "fotokit_miniscrap": {
        "one": "",
        "other": ""
      },
      "print_classic_with_border": {
        "7x00": "Mantiene le proporzioni originali dello scatto",
        "7x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
        "10x10": "Formato quadrato",
        "10x13": "Formato predefinito degli smartphone",
        "10x15": "Standard per cornici e album portafoto",
        "10x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
        "10x00": "Mantiene le proporzioni originali dello scatto",
        "12x12": "Formato quadrato",
        "12x16": "Formato predefinito degli smartphone",
        "12x18": "Standard per cornici e album portafoto",
        "12x00": "Mantiene le proporzioni originali dello scatto",
        "12x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
        "13x13": "Formato quadrato",
        "13x17": "Formato predefinito degli smartphone",
        "13x17.33": "Formato predefinito degli smartphone",
        "13x19": "Standard per cornici e album portafoto",
        "13x19.5": "Standard per cornici e album portafoto",
        "13x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
        "13x00": "Mantiene le proporzioni originali dello scatto",
        "15x15": "Formato quadrato",
        "15x20": " ",
        "15x22.5": " ",
        "15x22": " ",
        "15x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
        "15x00": "Mantiene le proporzioni originali dello scatto",
        "7x10": "Formato mini, ideale per i biglietti d'auguri"
      }
    },
    "format": {
      "10x13": "10x13 cm",
      "13x19.5": "13x19 cm",
      "8x10": "8x10 cm",
      "15x22.5": "15x22 cm",
      "20x27": "20x27 cm",
      "13x13": "13x13 cm",
      "20x30": "20x30 cm",
      "40x50": "40x50 cm",
      "50x50": "50x50 cm",
      "12x15": "12x15 cm",
      "15x15": "15x15 cm",
      "20x25": "20x25 cm",
      "13x17.33": "13x17 cm",
      "12x18": "12x18 cm",
      "40x40": "40x40 cm",
      "40x60": "40x60 cm",
      "15x20": "15x20 cm",
      "50x70": "50x70 cm",
      "50x60": "50x60 cm",
      "12x12": "12x12 cm",
      "50x75": "50x75 cm",
      "10x10": "10x10 cm",
      "7x10": "7x10 cm",
      "30x45": "30x45 cm",
      "10x15": "10x15 cm",
      "12x16": "12x16 cm",
      "30x40": "30x40 cm",
      "20x20": "20x20 cm",
      "8x_PANORAMIC": "8 cm variabile",
      "12x_PANORAMIC": "12 cm variabile",
      "30x_PANORAMIC": "30 cm variabile",
      "20x_PANORAMIC": "20 cm variabile",
      "13x_PANORAMIC": "13 cm variabile",
      "7x_PANORAMIC": "7 cm variabile",
      "10x_PANORAMIC": "10 cm variabile",
      "40x_PANORAMIC": "40 cm variabile",
      "15x_PANORAMIC": "15 cm variabile",
      "50x_PANORAMIC": "50 cm variabile",
      "13x19": "13x19 cm",
      "15x22": "15x22 cm",
      "13x17": "13x17 cm",
      "8x00": "8 cm variabile",
      "12x00": "12 cm variabile",
      "30x00": "30 cm variabile",
      "20x00": "20 cm variabile",
      "13x00": "13 cm variabile",
      "7x00": "7 cm variabile",
      "10x00": "10 cm variabile",
      "40x00": "40 cm variabile",
      "15x00": "15 cm variabile",
      "50x00": "50 cm variabile",
      "18x24": "18x24 cm",
      "24x24": "24x24 cm",
      "24x30": "24x30 cm",
      "24x36": "24x36 cm",
      "30x30": "30x30 cm",
      "35x35": "35x35 cm",
      "35x50": "35x50 cm",
      "30x60": "30x60 cm",
      "60x80": "60x80 cm",
      "70x100": "70x100 cm"
    },
    "band": {
      "7": "7 cm",
      "10": "10 cm",
      "12": "12 cm",
      "13": "13 cm",
      "15": "15 cm"
    },
    "bands-content": {
      "available-formats": "Formati disponibili"
    },
    "avoid-cuts-description": "Il formato consigliato si adatta meglio alle foto che hai selezionato per evitare tagli indesiderati.\n\nSe preferisci un altro formato, le tue foto saranno tagliate, ma potrai comunque sistemare le inquadrature nei prossimi passaggi.",
    "best-seller": "Best seller",
    "suggested": "Consigliato",
    "bands-price": {
      "7": "da 0,49€",
      "10": "da 0,59€",
      "12": "da 0,79€",
      "13": "da 0,99€",
      "15": "da 1,99€",
      "print_classic": {
        "7": "da 0,29€",
        "10": "da 0,35€",
        "12": "da 0,42€",
        "13": "da 0,48€",
        "15": "da 0,99€",
        "20": "da 1,99€",
        "30": "da 8,90€"
      },
      "poster": {
        "one": "",
        "other": ""
      },
      "print_vintage": {
        "one": "",
        "other": ""
      },
      "print_pro": {
        "7": "da 0,49€",
        "10": "da 0,59€",
        "12": "da 0,79€",
        "13": "da 0,99€",
        "15": "da 1,99€"
      },
      "poster_pro": {
        "one": "",
        "other": ""
      },
      "happy_case_classic": {
        "one": "",
        "other": ""
      },
      "happy_case_vintage": {
        "one": "",
        "other": ""
      },
      "photo_kit": {
        "one": "",
        "other": ""
      }
    },
    "box-style-title": "Scegli lo stile",
    "box-style": {
      "bloom": "Bloom",
      "christmas": "Magic Christmas",
      "love_is": "Love is",
      "moon": "Moon",
      "ocean": "Ocean",
      "sunshine": "Sunshine",
      "flower": "Flower",
      "game": "Game",
      "green": "Green",
      "life": "Life",
      "wonder": "Wonder",
      "jungle": "Jungle",
      "love_is_special": "Love you"
    },
    "box-style-price": "da {{price}}",
    "continue-with": "Prosegui con il {{format}}",
    "format-change": "Potrai cambiarlo in seguito",
    "format-adapt": "I formati variabili mantengono le proporzioni originali.\nOgni foto può avere dimensioni differenti",
    "papertype-title": "Scegli il tipo di carta",
    "papertype": {
      "photographic": "Carta fotografica Fujifilm",
      "inkjet": "Carta fotografica PhotoSì"
    },
    "papertype-content": {
      "photographic": "• Per chi ama la carta tradizionale\n• Ideale per scatti professionali",
      "inkjet": "• Resa cromatica eccellente\n• Scelta ecosostenibile"
    },
    "printtype": {
      "photographic": "Carta fotografica Fujifilm",
      "inkjet": "Carta fotografica PhotoSì"
    },
    "printtype-content": {
      "photographic": "• Carta tradizionale\n• Per scatti professionali",
      "inkjet": "• Resa cromatica eccellente\n• Scelta ecosostenibile"
    },
    "paperfinish-title": "Scegli la finitura",
    "paperfinish": {
      "glossy": "Lucida",
      "matte": "Opaca"
    },
    "paperfinish-content": {
      "glossy": "Un’esplosione di luce per i tuoi scatti più vivaci",
      "matte": "Finitura vellutata ed elegante, senza riflessi"
    },
    "paper": {
      "glossy": "Lucida",
      "matte": "Opaca"
    },
    "paper-content": {
      "glossy": "Un’esplosione di luce per i tuoi scatti più vivaci",
      "matte": "Finitura vellutata ed elegante, senza riflessi"
    },
    "suggested-lookup": "Consigliata",
    "option-prev": "Opzione precedente",
    "option-next": "Opzione successiva"
  },
  "group-header": {
    "add-product": "Aggiungi un prodotto",
    "add": "Aggiungi",
    "add-title": "Cosa vuoi aggiungere?",
    "add-new-product": "Aggiungi nuovo prodotto",
    "other-product": "Altri prodotti",
    "other-photo": "Altre foto",
    "add-product-2": "Aggiungi prodotto",
    "add-new-product-disabled": "Caricamento foto in corso",
    "add-more-products": "Aggiungi altri prodotti",
    "add-more-photos": "Aggiungi altre foto"
  },
  "group-action-bar": {
    "select": "Seleziona",
    "deselect": "Deseleziona",
    "selected": "{{count}} selezionato",
    "selected_plural": "{{count}} selezionati",
    "grid": "Vista",
    "delete-selected": "Elimina selezionati"
  },
  "groups": {
    "print_classic-title": "Stampe Classiche",
    "poster-title": "Poster e ingrandimenti",
    "print_classic-description": "da 0,19€ cad.",
    "poster-description": "da 3,99€ cad.",
    "print_vintage-title": "Stampe Vintage",
    "print_vintage-description": "da 0,35€ cad.",
    "print_pro-title": "Stampe Classiche Pro",
    "poster_pro-title": "Poster e ingrandimenti Pro",
    "happy_case_classic-title": "Happy Case Classic",
    "happy_case_vintage-title": "Happy Case Vintage",
    "fotokit_homedecor-title": "FotoKit Home Decor",
    "fotokit_miniscrap-title": "FotoKit Mini Scrap",
    "happy_case_classic-warning": "Ogni box deve contenere almeno {{photos}} foto, aggiungi le foto mancanti",
    "happy_case_vintage-warning": "Ogni box deve contenere almeno {{photos}} foto, aggiungi le foto mancanti",
    "fotokit_homedecor-warning": "Ogni FotoKit deve contenere almeno {{photos}} foto, aggiungi le foto mancanti.",
    "fotokit_miniscrap-warning": "Ogni FotoKit deve contenere almeno {{photos}} foto, aggiungi le foto mancanti.",
    "print_classic_with_border-title": "Stampe con bordo",
    "all-products-project-description": "Tutti i prodotti di questo progetto"
  },
  "modal-cut-alert": {
    "title": "Alcune immagini saranno tagliate",
    "description": "Ti consigliamo di controllare bene le inquadrature prima di proseguire",
    "review": "Controlla",
    "continue": "Continua"
  },
  "badge-crop-alert": {
    "cuts-check": "Controlla tagli"
  },
  "modal-cut-confirmation-alert": {
    "title": "Confermi tutte le inquadrature?",
    "description": "Confermando accetti i tagli che saranno applicati alle tue immagini",
    "review": "Rivedi",
    "continue": "Conferma",
    "title-confirm": "Confermi tutte le inquadrature?",
    "title-later": "Vuoi uscire senza salvare le inquadrature?",
    "description-confirm": "Una volta confermato l’ordine, le foto saranno stampate così come le vedi",
    "description-later": "Una volta confermato l’ordine, le foto saranno stampate così come le vedi",
    "review-confirm": "Rivedi",
    "review-later": "Rivedi tagli",
    "continue-confirm": "Salva e aggiungi al carrello",
    "continue-later": "Esci senza salvare"
  },
  "modal-adjust-crops": {
    "title": "Inquadratura",
    "save_and_close": "Salva e continua",
    "go-back": "Torna indietro",
    "review-later": "Esci senza salvare"
  },
  "help-button": {
    "privacy": "Informativa sulla privacy",
    "tutorial": "Rivedi Tutorial",
    "open": "Apri menu di aiuto"
  },
  "orientation": {
    "horizontal": "Orizzontale",
    "vertical": "Verticale"
  },
  "tutorial": {
    "step-1-text": "Qui potrai trovare le tue foto scelte per la stampa!",
    "step-1-cta": "Continua",
    "step-2-text": "Clicca sulle foto per selezionarle e personalizzarle come desideri!",
    "step-2-cta": "Continua",
    "step-3-text": "In questo menù potrai trovare gli strumenti per personalizzare le foto che hai selezionato!",
    "step-3-cta": "Ok, ho capito!",
    "group-text": "Qui potrai trovare le tue foto scelte per la stampa!",
    "group-cta": "Ok, ho capito!",
    "product-text": "Clicca sulle foto per selezionarle e personalizzarle come desideri!",
    "product-cta": "Continua",
    "toolbar-text": "In questo menù potrai trovare gli strumenti per personalizzare le foto che hai selezionato!",
    "toolbar-cta": "Ok, ho capito!",
    "zoom-text": "Prova a usare lo zoom per posizionare meglio la foto.",
    "zoom-cta": "Ok, ho capito!",
    "zoom-text-mobile": "Per spostare meglio la foto, usa lo zoom allargando le dita."
  },
  "bottom-bar": {
    "go-to-cart": "Aggiungi al carrello",
    "confirm": "Conferma"
  },
  "modal-delete-all": {
    "title": "Vuoi eliminare le foto selezionate?",
    "description": "Se cambi idea dovrai aggiungerle di nuovo al progetto.",
    "description_n": "Se cambi idea dovrai aggiungerle di nuovo al progetto.",
    "review": "Annulla",
    "confirm": "Elimina"
  },
  "bottom-sheet-avoid-cuts": {
    "title": "Come evitare tagli alle foto",
    "description": "Il formato consigliato si adatta meglio alle foto che hai selezionato per evitare tagli indesiderati.\n\nSe preferisci un altro formato, le tue foto saranno tagliate, ma potrai comunque sistemare le inquadrature nei prossimi passaggi."
  },
  "hints": {
    "border_not_available_for_product": "Il bordo selezionato non è disponibile per questo prodotto",
    "option_does_not_support_border": "L'opzione selezionata non supporta il bordo"
  },
  "text-tool-option": {
    "title": "Testo",
    "font": "Font",
    "style": "Stile",
    "alignment": "Allineamento",
    "color": "Colore testo",
    "button": "Applica",
    "size": "Dimensione font"
  },
  "modal-delete-from-drawer": {
    "title": "Vuoi davvero eliminare questa foto?",
    "description": "Se cambi idea dovrai aggiungerla di nuovo al progetto.",
    "abort": "Annulla",
    "confirm": "Conferma"
  },
  "badge-min-products": {
    "missing-products": "Quantità minima non raggiunta"
  },
  "modal-over-limit-products": {
    "title": "Hai superato il limite massimo di {{limit}} foto\nper la tua Happy Case.",
    "description": "Vuoi aggiungere un’altra Box o rimuovere qualche foto?",
    "remove": "Rimuovi alcune foto",
    "add": "Acquista un'altra Box",
    "title_happy_case_classic": "Hai superato il limite massimo di {{limit}} foto\nper la tua Happy Case.",
    "title_happy_case_vintage": "Hai superato il limite massimo di {{limit}} foto\nper la tua Happy Case.",
    "title_fotokit_homedecor": "Hai superato il limite massimo di {{limit}} per un FotoKit.",
    "title_fotokit_miniscrap": "Hai superato il limite massimo di {{limit}} per un FotoKit.",
    "description_happy_case_classic": "Vuoi aggiungere un’altra Box o rimuovere qualche foto?",
    "description_happy_case_vintage": "Vuoi aggiungere un’altra Box o rimuovere qualche foto?",
    "description_fotokit_homedecor": "Vuoi aggiungere un altro FotoKit o rimuovere qualche foto?",
    "description_fotokit_miniscrap": "Vuoi aggiungere un altro FotoKit o rimuovere qualche foto?",
    "add_happy_case_classic": "Acquista un'altra Box",
    "add_happy_case_vintage": "Acquista un'altra Box",
    "add_fotokit_homedecor": "Aggiungi un altro FotoKit",
    "add_fotokit_miniscrap": "Aggiungi un altro FotoKit"
  },
  "modal-min-products-alert": {
    "title": "La quantità minima di foto non è stata raggiunta",
    "description": "Aggiungi le foto mancanti per completare la box.",
    "cta": "Torna all'editor",
    "description_happy_case_classic": "Aggiungi le foto mancanti per completare la box e aggiungerla al carrello.",
    "description_happy_case_vintage": "Aggiungi le foto mancanti per completare la box e aggiungerla al carrello.",
    "description_fotokit_homedecor": "Aggiungi le foto mancanti per completare il FotoKit.",
    "description_fotokit_miniscrap": "Aggiungi le foto mancanti per completare il FotoKit e aggiungerlo al carrello."
  },
  "upload-smartphone": {
    "title": "Seleziona le foto dalla galleria del telefono",
    "description": "per proseguire con la creazione del tuo progetto dal computer",
    "cta": "Seleziona foto",
    "uploading-title": "Stiamo caricando le tue foto",
    "uploading-description": "Non chiudere l'applicazione, ci vorrà solo qualche istante",
    "uploaded-title": "Le tue foto sono state caricate sul computer",
    "uploaded-description": "Se vuoi aggiungerne altre clicca qui sotto. Altrimenti chiudi la pagina.",
    "uploaded-cta": "Aggiungi altre foto",
    "error-retry-title": "Caricamento fallito",
    "error-retry-description": "Controlla il collegamento alla rete Internet e riprova. Se il problema persiste, contatta la nostra assistenza.",
    "error-fatal-title": "C'è qualcosa che non va",
    "error-fatal-description": "Torna alla schermata con il QR code, ricarica la pagina e riprova.",
    "upload-again-title": "Caricamento interrotto",
    "upload-again-description": "Non è stato possibile caricare tutte le foto.\nControlla il collegamento alla rete Internet e riprova. Se il problema persiste, contatta la nostra assistenza.",
    "upload-again-cta": "Torna alla selezione foto",
    "retry": "Riprova",
    "upload-corrupted-title": "Non è stato possibile caricare uno o più file",
    "upload-corrupted-description-tail-counter": " ed altri {{counter_file}} potrebbero essere corrotti o in un formato non supportato.",
    "upload-corrupted-description-tail": " potrebbero essere corrotti o in un formato non supportato.",
    "upload-corrupted-description-head": "I seguenti file: ",
    "upload-corrupted-url": "Mostra l’elenco completo",
    "upload-corrupted-cta": "Seleziona foto"
  },
  "upload-family-friends": {
    "title": "Seleziona e condividi le tue foto!",
    "description": "Contribuirai a tenere al sicuro i vostri ricordi per sempre.",
    "cta": "Seleziona foto",
    "uploading-title": "Stiamo caricando le tue foto",
    "uploading-description": "Non chiudere l'applicazione, ci vorrà solo qualche istante.",
    "uploaded-title": "Caricamento completato! Avvisa che hai portato a termine la missione!",
    "uploaded-description": "Grazie per il tuo prezioso contributo.",
    "uploaded-cta": "Aggiungi altre foto",
    "redirect": "Vuoi salvare ricordi anche tu?",
    "redirect-cta": "Scopri i nostri prodotti",
    "error-retry-title": "Caricamento fallito",
    "error-retry-description": "Controlla il collegamento alla rete Internet e riprova. Se il problema persiste, contatta la nostra assistenza.",
    "error-fatal-title": "C'è qualcosa che non va",
    "error-fatal-description": "Chiedi alla persona che ti ha inviato questo link di inviartene uno nuovo per poter caricare le foto",
    "upload-again-title": "Caricamento interrotto",
    "upload-again-description": "Non è stato possibile caricare tutte le foto.\nControlla il collegamento alla rete Internet e riprova. Se il problema persiste, contatta la nostra assistenza.",
    "upload-again-cta": "Torna alla selezione foto",
    "retry": "Riprova",
    "upload-corrupted-title": "Non è stato possibile caricare uno o più file",
    "upload-corrupted-description-tail-counter": " ed altri {{counter_file}} potrebbero essere corrotti o in un formato non supportato.",
    "upload-corrupted-description-tail": " potrebbero essere corrotti o in un formato non supportato.",
    "upload-corrupted-description-head": "I seguenti file: ",
    "upload-corrupted-url": "Mostra l’elenco completo",
    "upload-corrupted-cta": "Seleziona foto"
  },
  "modal-picker-smartphone": {
    "upload": "Carica le foto dal tuo smartphone",
    "step-1-title": "Inquadra il QR-code",
    "step-1-description": "con la fotocamera del tuo telefono",
    "step-2-title": "Seleziona le foto",
    "step-2-description": "dalla galleria del telefono",
    "step-3-title": "Visualizza qui le tue foto in anteprima",
    "step-3-description": "poi clicca su conferma",
    "troubleshooting": "Problemi con il QR code?\nCopia e incolla questo link nel browser del tuo smartphone",
    "copy-cta": "Copia link",
    "connected-title": "Connessione attiva!",
    "connected-description": "Ora puoi selezionare le foto dalla galleria del telefono, poi le vedrai qui in anteprima.",
    "copied": "Link copiato!"
  },
  "modal-picker-family-friends": {
    "upload": "Carica le foto dei tuoi amici e familiari",
    "step-1-title": "Copia e condividi il link con i tuoi cari",
    "step-1-description": "tramite sms, WhatsApp, e-mail...",
    "step-2-title": "Chiedi loro di caricare le foto e di avvisarti",
    "step-2-description": "perché il link scade dopo pochi giorni",
    "step-3-title": "Visualizza qui le foto in anteprima",
    "step-3-description": "poi clicca su conferma",
    "copy-cta": "Copia link",
    "share-cta": "Condividi link",
    "share-message": "Invito a caricare foto nel progetto",
    "or-choice": "Oppure"
  },
  "modal-below-limit-products": {
    "title": "Questo prodotto prevede almeno {{limit}} foto.",
    "description": "Aggiungi le foto mancanti per completare la box.",
    "cta": "Aggiungi ora",
    "close": "Aggiungi dopo",
    "description_happy_case_classic": "Aggiungi le foto mancanti per completare la box.",
    "description_happy_case_vintage": "Aggiungi le foto mancanti per completare la box.",
    "description_fotokit_homedecor": "Aggiungi le foto mancanti per completare il FotoKit.",
    "description_fotokit_miniscrap": "Aggiungi le foto mancanti per completare il FotoKit."
  },
  "modal-upload-error": {
    "title": "File non caricati",
    "cta": "Ok, grazie",
    "description": "Potrebbe essere corrotto o in un formato non supportato.  Ti preghiamo di verificare e riprovare."
  },
  "formats-content": {
    "print_classic": {
      "7x00": "Mantiene le proporzioni originali dello scatto",
      "7x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "10x10": "Quadrato",
      "10x13": "Formato predefinito degli smartphone",
      "10x15": "Standard per cornici e album portafoto",
      "10x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "10x00": "Mantiene le proporzioni originali dello scatto",
      "12x12": "Quadrato",
      "12x16": "Formato predefinito degli smartphone",
      "12x18": "Standard per cornici e album portafoto",
      "12x00": "Mantiene le proporzioni originali dello scatto",
      "12x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "13x13": "Quadrato",
      "13x17": "Formato predefinito degli smartphone",
      "13x17.33": "Formato predefinito degli smartphone",
      "13x19": "Standard per cornici e album portafoto",
      "13x19.5": "Standard per cornici e album portafoto",
      "13x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "13x00": "Mantiene le proporzioni originali dello scatto",
      "15x15": "Quadrato",
      "15x20": "Formato predefinito degli smartphone",
      "15x22.5": "Standard per cornici e album portafoto",
      "15x22": "Standard per cornici e album portafoto",
      "15x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "15x00": "Mantiene le proporzioni originali dello scatto"
    },
    "poster": {
      "20x20": "",
      "20x27": "",
      "20x30": "",
      "30x40": "",
      "30x45": "",
      "40x40": "",
      "40x50": "",
      "40x60": "",
      "50x50": "",
      "50x70": "",
      "50x75": ""
    },
    "print_vintage": {
      "8x10": "Piccolo formato, grandi emozioni da custodire.",
      "12x15": "La misura giusta per rivivere ogni istante con calore.",
      "20x25": "Un ricordo che prende spazio e illumina la stanza."
    },
    "print_pro": {
      "10x13": "Formato predefinito degli smartphone",
      "10x15": "Standard per cornici e album portafoto",
      "12x16": "Formato predefinito degli smartphone",
      "12x18": "Standard per cornici e album portafoto",
      "13x17.33": "Formato predefinito degli smartphone",
      "13x17": "Formato predefinito degli smartphone",
      "13x19": "Standard per cornici e album portafoto",
      "13x19.5": "Standard per cornici e album portafoto",
      "15x20": "Formato predefinito degli smartphone",
      "15x22.5": "Standard per cornici e album portafoto",
      "15x22": "Standard per cornici e album portafoto"
    },
    "poster_pro": {
      "20x20": "",
      "18x24": "",
      "20x25": "",
      "24x24": "",
      "20x30": "",
      "24x30": "",
      "24x36": "",
      "30x30": "",
      "30x45": "",
      "30x40": "",
      "35x35": "",
      "40x40": "",
      "35x50": "",
      "30x60": "",
      "40x50": "",
      "50x50": "",
      "40x60": "",
      "50x70": "",
      "50x60": "",
      "50x75": "",
      "60x80": "",
      "70x100": ""
    },
    "happy_case_classic": {
      "one": "",
      "other": ""
    },
    "happy_case_vintage": {
      "one": "",
      "other": ""
    },
    "fotokit_homedecor": {
      "one": "",
      "other": ""
    },
    "fotokit_miniscrap": {
      "one": "",
      "other": ""
    },
    "suggested": "Ideale per evitare tagli alle tue foto",
    "print_classic_with_border": {
      "7x00": "Mantiene le proporzioni originali dello scatto",
      "7x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "10x10": "Quadrato",
      "10x13": "Formato predefinito degli smartphone",
      "10x15": "Standard per cornici e album portafoto",
      "10x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "10x00": "Mantiene le proporzioni originali dello scatto",
      "12x12": "Quadrato",
      "12x16": "Formato predefinito degli smartphone",
      "12x18": "Standard per cornici e album portafoto",
      "12x00": "Mantiene le proporzioni originali dello scatto",
      "12x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "13x13": "Quadrato",
      "13x17": "Formato predefinito degli smartphone",
      "13x17.33": "Formato predefinito degli smartphone",
      "13x19": "Standard per cornici e album portafoto",
      "13x19.5": "Standard per cornici e album portafoto",
      "13x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "13x00": "Mantiene le proporzioni originali dello scatto",
      "15x15": "Quadrato",
      "15x20": "Formato predefinito degli smartphone",
      "15x22.5": "Standard per cornici e album portafoto",
      "15x22": "Standard per cornici e album portafoto",
      "15x_PANORAMIC": "Mantiene le proporzioni originali dello scatto",
      "15x00": "Mantiene le proporzioni originali dello scatto"
    }
  },
  "unsupportedEnv": {
    "title": "{{env}} non aggiornato",
    "description": "La versione del tuo {{env}} non è supportata.\nAggiornalo all’ultima versione per continuare a usare l’editor senza problemi.",
    "incognitoTitle": "Modalità incognito non supportata",
    "incognitoDescription": "Apri l’editor in una finestra normale per continuare.\nSe stavi aprendo un progetto salvato, non l’hai perso:\npotrai trovarlo accedendo all’editor con una navigazione standard.",
    "noAvailableSpaceTitle": "Spazio di archiviazione esaurito",
    "noAvailableSpaceDescription": "Libera spazio sul dispositivo eliminando foto o app che non usi, poi ricarica la pagina.",
    "noAvailableSpaceCta": "Ricarica la pagina"
  },
  "toast-share-photos": {
    "title": "Nuove foto caricate",
    "description": "Vuoi vederle?",
    "cta-confirm": "Vedi",
    "cta-decline": "Non ora",
    "description-single": "Vuoi vederla?"
  },
  "group-action-bar-v3": {
    "select": "Seleziona tutto",
    "deselect": "Deseleziona tutto",
    "selected": " foto selezionata",
    "selected_plural": " foto selezionate",
    "delete-selected": "Elimina selezionati",
    "duplicate-selected": "Duplica selezionati",
    "add": "Aggiungi altre foto",
    "box-style": "Cambia stile",
    "box-style-hint": "Cambia stile della box",
    "delete-selected-short": "Elimina",
    "duplicate-selected-short": "Duplica",
    "add-disabled": "Caricamento foto in corso"
  },
  "modal-network": {
    "title": "Non c’è connessione Internet",
    "description": "Controlla il collegamento al wi-fi o le impostazioni di rete.",
    "sub-description-head": "Il tuo progetto verrà comunque salvato in automatico nella sezione",
    "sub-description-tail": "I tuoi progetti",
    "cta": "Ok, grazie",
    "sub-description": "Il tuo progetto verrà comunque salvato in automatico nella sezione"
  },
  "group-suffix": {
    "10x13": "10x13",
    "13x19.5": "13x19",
    "8x10": "8x10",
    "15x22.5": "15x22",
    "20x27": "20x27",
    "13x13": "13x13",
    "20x30": "20x30",
    "40x50": "40x50",
    "50x50": "50x50",
    "12x15": "12x15",
    "15x15": "15x15",
    "20x25": "20x25",
    "13x17.33": "13x17",
    "12x18": "12x18",
    "40x40": "40x40",
    "40x60": "40x60",
    "15x20": "15x20",
    "50x70": "50x70",
    "50x60": "50x60",
    "12x12": "12x12",
    "50x75": "50x75",
    "10x10": "10x10",
    "7x10": "7x10",
    "30x45": "30x45",
    "10x15": "10x15",
    "12x16": "12x16",
    "30x40": "30x40",
    "20x20": "20x20",
    "8x_PANORAMIC": "8x",
    "12x_PANORAMIC": "12x",
    "30x_PANORAMIC": "30x",
    "20x_PANORAMIC": "20x",
    "13x_PANORAMIC": "13x",
    "7x_PANORAMIC": "7x",
    "10x_PANORAMIC": "10x",
    "40x_PANORAMIC": "40x",
    "15x_PANORAMIC": "15x",
    "50x_PANORAMIC": "50x",
    "13x19": "13x19",
    "15x22": "15x22",
    "13x17": "13x17",
    "8x00": "8x",
    "12x00": "12x",
    "30x00": "30x",
    "20x00": "20x",
    "13x00": "13x",
    "7x00": "7x",
    "10x00": "10x",
    "40x00": "40x",
    "15x00": "15x",
    "50x00": "50x",
    "18x24": "18x24",
    "24x24": "24x24",
    "24x30": "24x30",
    "24x36": "24x36",
    "30x30": "30x30",
    "35x35": "35x35",
    "35x50": "35x50",
    "30x60": "30x60",
    "60x80": "60x80",
    "70x100": "70x100"
  },
  "modal-new-version-available": {
    "title": "Nuova versione disponibile",
    "description": "Ricarica la pagina per continuare con l’ultima versione.\nIl progetto verrà salvato automaticamente nella sezione <bold>I tuoi progetti<\/bold>.",
    "cta": "Ricarica"
  },
  "zoom-image": {
    "title": "Anteprima",
    "go-back": "Torna indietro",
    "photos": "{{counter}} foto"
  },
  "bottom-sheet-group-tabs": {
    "title": "Tutti i prodotti di questo set"
  },
  "modal-max-products-alert": {
    "title": "La quantità massima di foto è stata superata",
    "description": "Rimuovi le foto in eccesso per continuare.",
    "cta": "Torna all'editor",
    "description_happy_case_classic": "Rimuovi le foto in eccesso per completare la box e aggiungerla al carrello.",
    "description_happy_case_vintage": "Rimuovi le foto in eccesso per completare la box e aggiungerla al carrello.",
    "description_fotokit_homedecor": "Rimuovi le foto in eccesso per completare il FotoKit.",
    "description_fotokit_miniscrap": "Rimuovi le foto in eccesso per completare il FotoKit e aggiungerlo al carrello."
  },
  "modal-no-available-space": {
    "title": "Spazio di archiviazione esaurito",
    "description": "Libera spazio sul dispositivo eliminando foto o app che non usi, poi ricarica la pagina.",
    "cta": "Ricarica la pagina"
  },
  "modal-product-not-available": {
    "title": "Prodotto non disponibile",
    "description-saved": "Le tue modifiche sono salvate. Potrai aggiungere il progetto al carrello appena il prodotto torna disponibile.",
    "description-guest": "Le tue modifiche sono salvate: accedi per ritrovare il progetto nella pagina “I tuoi progetti”. Potrai aggiungerlo al carrello appena il prodotto torna disponibile.",
    "continue-editing": "Continua a modificare",
    "back-to-projects": "Torna ai progetti",
    "login": "Accedi"
  }
}